import styles from "./Section.module.css";
import { FC, HTMLAttributes } from "react";

const Section: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const { className, ...rest } = props;
  const combinedClassName = className
    ? `${styles["root"]} ${className}`
    : styles["root"];
  return (
    <div className={combinedClassName} {...rest}>
      {props.children}
    </div>
  );
};

export default Section;
